"use client";

import React, { useState } from "react";
import { SectionContentProps } from "../../types";
import LogoUploader from "../../sections/header/LogoUploader";
import { PiListBold, PiXBold } from "react-icons/pi";

export default function SaasHeader({
  content,
  onContentChange,
  isSelected,
  defaultLogo,
}: SectionContentProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const navItems = content.navItems || ["Product", "Solutions", "Pricing", "Docs"];

  const handleLogoChange = (newLogoUrl: string) => {
    onContentChange?.({ ...content, logo: newLogoUrl });
  };

  return (
    <header
      className={`w-full transition-all relative z-50 bg-slate-900 border-b border-slate-800 ${isSelected ? "ring-2 ring-blue-500 z-50" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between py-4">
        <div className="flex items-center flex-shrink-0">
          <LogoUploader
            currentLogo={content.logo}
            defaultLogo={defaultLogo || "SaaS Co."}
            onLogoChange={handleLogoChange}
            heightClass="h-8"
            primaryColor="#3B82F6"
            secondaryColor="#60A5FA"
            companyName={content.companyName || "SaaS Co."}
            isEditing={!!onContentChange}
          />
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              className="text-sm font-medium text-slate-300 hover:text-white transition-colors"
            >
              {item}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={content.ctaLink || "#signup"}
            className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm transition-all"
          >
            {content.ctaText || "Get Started"}
          </a>
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-slate-300 hover:text-white p-2"
          >
            {isMobileMenuOpen ? <PiXBold className="h-6 w-6" /> : <PiListBold className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-slate-900 border-t border-slate-800 py-4 px-6 space-y-4">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-slate-300 hover:text-white py-1"
            >
              {item}
            </a>
          ))}
          <a
            href={content.ctaLink || "#signup"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-center py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm"
          >
            {content.ctaText || "Get Started"}
          </a>
        </div>
      )}
    </header>
  );
}
